export default __webpack_public_path__ + "static/media/dog-placeholder-oval.d317c09a.png";